'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var pipe = require('it-pipe');

var lp = require('it-length-prefixed');

var PeerInfo = require('peer-info');

var Message = require('../message');

var handlers = require('./handlers');

var utils = require('../utils');

module.exports = function (dht) {
  var log = utils.logger(dht.peerInfo.id, 'rpc');
  var getMessageHandler = handlers(dht);
  /**
   * Process incoming DHT messages.
   * @param {PeerInfo} peer
   * @param {Message} msg
   * @returns {Promise<Message>}
   *
   * @private
   */

  function handleMessage(_x, _x2) {
    return _handleMessage.apply(this, arguments);
  }
  /**
   * Handle incoming streams on the dht protocol.
   * @param {Object} props
   * @param {DuplexStream} props.stream
   * @param {Connection} props.connection connection
   * @returns {Promise<void>}
   */


  function _handleMessage() {
    _handleMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer, msg) {
      var handler;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // get handler & execute it
              handler = getMessageHandler(msg.type);
              _context3.prev = 1;
              _context3.next = 4;
              return dht._add(peer);

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              log.error('Failed to update the kbucket store', _context3.t0);

            case 9:
              if (handler) {
                _context3.next = 12;
                break;
              }

              log.error("no handler found for message type: ".concat(msg.type));
              return _context3.abrupt("return");

            case 12:
              return _context3.abrupt("return", handler(peer, msg));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6]]);
    }));
    return _handleMessage.apply(this, arguments);
  }

  return /*#__PURE__*/function () {
    var _onIncomingStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var stream, connection, peerInfo, idB58Str;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              stream = _ref2.stream, connection = _ref2.connection;
              _context2.next = 3;
              return PeerInfo.create(connection.remotePeer);

            case 3:
              peerInfo = _context2.sent;
              _context2.prev = 4;
              _context2.next = 7;
              return dht._add(peerInfo);

            case 7:
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](4);
              log.error(_context2.t0);

            case 12:
              idB58Str = peerInfo.id.toB58String();
              log('from: %s', idB58Str);
              _context2.next = 16;
              return pipe(stream.source, lp.decode(), function (source) {
                return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg, desMessage, res;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _context.prev = 2;
                          _iterator = _asyncIterator(source);

                        case 4:
                          _context.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          _step = _context.sent;
                          _iteratorNormalCompletion = _step.done;
                          _context.next = 10;
                          return _awaitAsyncGenerator(_step.value);

                        case 10:
                          _value = _context.sent;

                          if (_iteratorNormalCompletion) {
                            _context.next = 23;
                            break;
                          }

                          msg = _value;
                          // handle the message
                          desMessage = Message.deserialize(msg.slice());
                          _context.next = 16;
                          return _awaitAsyncGenerator(handleMessage(peerInfo, desMessage));

                        case 16:
                          res = _context.sent;

                          if (!res) {
                            _context.next = 20;
                            break;
                          }

                          _context.next = 20;
                          return res.serialize();

                        case 20:
                          _iteratorNormalCompletion = true;
                          _context.next = 4;
                          break;

                        case 23:
                          _context.next = 29;
                          break;

                        case 25:
                          _context.prev = 25;
                          _context.t0 = _context["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 29:
                          _context.prev = 29;
                          _context.prev = 30;

                          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                            _context.next = 34;
                            break;
                          }

                          _context.next = 34;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 34:
                          _context.prev = 34;

                          if (!_didIteratorError) {
                            _context.next = 37;
                            break;
                          }

                          throw _iteratorError;

                        case 37:
                          return _context.finish(34);

                        case 38:
                          return _context.finish(29);

                        case 39:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
                }))();
              }, lp.encode(), stream.sink);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 9]]);
    }));

    function onIncomingStream(_x3) {
      return _onIncomingStream.apply(this, arguments);
    }

    return onIncomingStream;
  }();
};